<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9.914" viewBox="0 0 14 9.914" class="scaling-svg">
      <path
        d="M10.506,9.6a2.3,2.3,0,0,1-1.161.317,2.374,2.374,0,0,1-1.623-.655,2.291,2.291,0,0,1-.713-1.674A2.335,2.335,0,0,1,9.346,5.256a2.277,2.277,0,0,1,1.16.317,2.277,2.277,0,0,1,1.161-.317,2.33,2.33,0,1,1,0,4.659A2.283,2.283,0,0,1,10.506,9.6ZM10.5,7.585a1.177,1.177,0,1,0,1.177-1.177A1.179,1.179,0,0,0,10.5,7.585Zm-2.337,0A1.178,1.178,0,0,0,9.335,8.762a1.209,1.209,0,0,0,.309-.041,2.332,2.332,0,0,1,0-2.273,1.163,1.163,0,0,0-.309-.042A1.178,1.178,0,0,0,8.159,7.585Zm-6.27.575A1.891,1.891,0,0,1,0,6.27V1.889A1.891,1.891,0,0,1,1.889,0h9.053a1.891,1.891,0,0,1,1.889,1.889v2.19a.575.575,0,0,1-1.15,0V3.194H1.15V6.27a.74.74,0,0,0,.739.739H5.832a.575.575,0,0,1,0,1.151ZM1.15,1.889v.155H11.682V1.889a.74.74,0,0,0-.739-.739H1.889A.74.74,0,0,0,1.15,1.889Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CreditCardStatementsIcon extends Vue {}
</script>

<style>
</style>
